import { Box, Chip, ListItem, ListItemButton, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export function MoveToPositionListItem({ item }) {
    const { onSelect, currentTask, selectedTask } = useBoundContext()
    const titleFontWeight = item.isHeader ? 700 : 400
    const positionLabel = item.isHeader ? "-" : item.$index

    if (item === currentTask) {
        return (
            <ListItem
                sx={{
                    py: 0.75,
                    bgcolor: "action.selected",
                    px: 2,
                }}
                data-cy="move-to-position-item-current"
            >
                <Box display="flex" alignItems="center" gap={1} width="100%">
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ minWidth: 24 }}>
                        {positionLabel}
                    </Typography>
                    <TruncatedTypography variant="body2" flex={1} sx={{ fontWeight: titleFontWeight }}>
                        {item.title}
                    </TruncatedTypography>
                    {item.isHeader && <Chip label="Header" size="small" variant="outlined" sx={{ height: 18 }} />}
                    <Typography variant="caption">current</Typography>
                </Box>
            </ListItem>
        )
    }

    return (
        <ListItemButton
            selected={item === selectedTask}
            onClick={handleSelect}
            sx={{ py: 0.75, px: 2 }}
            data-cy="move-to-position-item"
        >
            <Box display="flex" alignItems="center" gap={1} width="100%">
                <TruncatedTypography variant="caption" color="text.secondary" sx={{ minWidth: 24 }}>
                    {positionLabel}
                </TruncatedTypography>
                <Typography variant="body2" sx={{ fontWeight: titleFontWeight }} flex={1}>
                    {item.title}
                </Typography>
                {item.isHeader && <Chip label="Header" size="small" variant="outlined" sx={{ height: 18 }} />}
            </Box>
        </ListItemButton>
    )

    function handleSelect() {
        onSelect(item)
    }
}
